import {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box, IconButton, Modal } from '@mui/material';
import { DataGrid, esES } from '@mui/x-data-grid';
import CloseIcon from '@mui/icons-material/Close';
import {setDashboardNodeSelected, getInmuebleOrDeviceNodes, getDevicesInumeble} from '../../../store/fuse/dashboard';
import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  // width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  height: '60%',
  width: '90%',
};

const NodesModal = ({ openModal, handleCloseModal, loading, nodesData, filtersSelected, colorInmueble,redirectPath = '/dashboard', type = 'nodo', setModalType }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const nodes = useSelector((state) => state?.fuse?.monitoreo?.topologicNodes);
  const handleCloseModalDevice = () => setOpen(false);

  const darkMode = useSelector((state) => state?.fuse?.dashboard?.darkMode);
  const [nodesDataInm, setNodesDataInm] = useState([]);
  
  const nodeColumns = [
    {
      field: 'dsnodo',
      headerName: 'Nombre',
      flex: 1,
    },
    {
      field: 'dsgrupoinmueble',
      headerName: 'Grupo',
      flex: 1,
    },
    {
      field: 'dstipodispositivo',
      headerName: 'Tipo Dispositivo',
      flex: 1,
    },
    {
      field: 'dscriticidad',
      headerName: 'Criticidad',
      flex: 1,
    },
  ];

  const interfaceColumns = [
    {
      field: 'dsnodo',
      headerName: 'Nombre',
      flex: 1,
    },
    {
      field: 'dsinterface',
      headerName: 'Interface',
      flex: 1,
    },
    // {
    //   field: 'dsgrupoinmueble',
    //   headerName: 'Grupo',
    //   flex: 1,
    // },
    {
      field: 'dstipodispositivo',
      headerName: 'Tipo Dispositivo',
      flex: 1,
    },
    {
      field: 'dscriticidad',
      headerName: 'Criticidad',
      flex: 1,
    },
  ];

  const inmueblesColumns = [
    {
      field: 'dsinmueble',
      headerName: 'Inmueble',
      flex: 1,
    },
    {
      field: 'dsgrupoinmueble',
      headerName: 'Grupo',
      flex: 1,
    },
    {
      field: 'consumo',
      headerName: 'Consumo',
      flex: 1,
    },
    {
      field: 'servicio',
      headerName: 'Servicio',
      flex: 1,
    },
    {
      field: 'dscriticidadsitio',
      headerName: 'Criticidad',
      flex: 1,
    },
  ];

  const modalColumns = {
    interface: interfaceColumns,
    nodo: nodeColumns,
    inmueble: inmueblesColumns,
  };

  const handleRowClick = async (params) => {
    const chosenNodo = nodes.find((nodo) => nodo.nodo === params.row.dsnodo);
    if (type !== 'inmueble' && type !== 'interface') {
      dispatch(setDashboardNodeSelected(redirectPath, params.row.dsnodo));
      navigate(`/dashboard/${params.row.nodeid}`);
    }else if (type === 'interface') {
      dispatch(setDashboardNodeSelected(redirectPath, params.row.dsnodo));
      navigate(`/dashboard/${chosenNodo.id}`);
    } else if (type === 'inmueble') {
      setModalType('node')
      handleCloseModal()
      await axios.post(`${API_URL}/ms-dashboard/tablero/indicadores/detalle/dispositivos`, {
        grupoInmuebleId: filtersSelected?.grupo || 0,
        inmuebleId:  parseInt(params.row.inmuebleid, 10) || 0,
        regionId: filtersSelected?.region || 0,
        fechaFin: filtersSelected?.fechaFin || '',
        fechaIni: filtersSelected?.fechaIni || '',
        metricaId: 0,
        nodeId: chosenNodo.id || 0,
        verde: colorInmueble === 'verde',
        amarillo: colorInmueble === 'amarillo',
        rojo: colorInmueble === 'rojo',
        gris: colorInmueble === 'gris',
        criticidadId: 0,
        dispositivoId: 0,
        tipoAnchoBanda: 0,
        servicioId: 0,
      }).then(({data}) => {
        const nodes = data.data.map((node, index) => ({...node, id: index}));
        setNodesDataInm(nodes)
        setOpen(true)
      }).catch((error)=>{
        console.error(error)
      })
    }
  };
  
  return (
    <>
    <Modal open={openModal} onClose={handleCloseModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <Box display="flex" justifyContent="center" alignItems="center" sx={modalStyle} flexDirection="column">
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', width: '100%' }}>
          <IconButton aria-label="close-ticket-modal-btn" size="medium" onClick={handleCloseModal}>
            <CloseIcon />
          </IconButton>
        </div>
        <DataGrid
          sx={{
            width: '100%',
            '& .MuiDataGrid-row:hover': {
              // eslint-disable-next-line no-nested-ternary
              background: '#01A9DB',
              cursor:  'pointer',
            },
          }}
          loading={loading}
          rows={nodesData}
          columns={modalColumns[type]}
          onRowClick={handleRowClick}
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          isRowSelectable={type === 'interface'}
        />
      </Box>
    </Modal>
      <Modal open={open} onClose={handleCloseModalDevice} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box display="flex" justifyContent="center" alignItems="center" sx={modalStyle} flexDirection="column">
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', width: '100%' }}>
            <IconButton aria-label="close-ticket-modal-btn" size="medium" onClick={handleCloseModalDevice}>
              <CloseIcon  />
            </IconButton>
          </div>
          <DataGrid
            sx={{
              width: '100%',
              '& .MuiDataGrid-row:hover': {
                // eslint-disable-next-line no-nested-ternary
                background: '#01A9DB',
                cursor: 'pointer' ,
              },
            }}
            loading={loading}
            rows={nodesDataInm}
            columns={nodeColumns}
            onRowClick={handleRowClick}
            localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          />
        </Box>
      </Modal>
    </>
  );
};

export default NodesModal;
